// @flow
import * as React from 'react';
import jsonp from 'jsonp';
import config from '../config';

type Props = {
  value: ?string,
  placeholder: ?string,
  disabled?: boolean,
  onChange: Function
};

type Suggestion = {
  Highlight: any,
  Value: any,
  id: number | string
};

type State = {
  value: ?string,
  showSuggestions: boolean,
  suggestions: Suggestion[],
  focusedOption: number
};

class Autocomplete extends React.Component<Props, State> {
  resultsLimit: number;

  constructor(props: Props) {
    super(props);

    this.state = {
      value: '',
      showSuggestions: false,
      suggestions: [],
      focusedOption: -1
    };
    this.resultsLimit = 10;
  }

  componentDidMount() {
    this.setState({ value: this.props.value });
  }

  componentWillReceiveProps(nextProps: Props) {
    const currentValue = this.props.value;
    const newValue = nextProps.value;
    if (newValue !== currentValue) {
      this.setState({ value: newValue });
    }
  }

  onChange = (event: Event) => {
    // $FlowFixMe
    const value = event.target.value;
    this.setState({ value });

    // only display the suggestions if there are more than 2 letters
    const minChars = value.length > 2;
    if (minChars) {
      this.getSuggestions(value);
    }

    // run higher level change function
    this.props.onChange(event);
  };

  getSuggestions = (value: string) => {
    const datasets = 'gnaf';
    const endpoint = `https://api.mapds.com.au/place/suggest/?key=${
      config.mdsApiKey
    }&query=${value}&limit=${this.resultsLimit}&datasets=${datasets}`;
    const options = {
      method: 'GET',
      headers: { Accept: 'application/jsonp' }
    };
    return jsonp(endpoint, options, (err, data) => {
      if (err) {
        console.error('Error getting suggestions', err);
      } else {
        this.setState({
          suggestions: data.Results,
          showSuggestions: true
        });
      }
    });
  };

  setItem = (value: string) => {
    this.setState(
      { value, showSuggestions: false },
      this.props.onChange(value)
    );
  };

  onKeyDown = (event: Event) => {
    if (!this.state.showSuggestions) return;
    // $FlowFixMe
    switch (event.keyCode) {
      case 13:
        // enter
        event.preventDefault();
        this.selectFocusedOption();
        break;
      case 27:
        // escape
        this.hideSuggestions();
        event.stopPropagation();
        break;
      case 38:
        // up
        this.focusPreviousOption();
        break;
      case 40:
        // down
        this.focusNextOption();
        break;
      default:
        return;
    }
  };

  focusPreviousOption = () => {
    const currentFocusedOption = this.state.focusedOption;
    const focusedOption = currentFocusedOption - 1;

    if (currentFocusedOption > -1) {
      this.setState({ focusedOption });
    }
  };

  focusNextOption = () => {
    const currentFocusedOption = this.state.focusedOption;
    const focusedOption = currentFocusedOption + 1;

    if (currentFocusedOption < this.resultsLimit) {
      this.setState({ focusedOption });
    }
  };

  selectFocusedOption = () => {
    const selectedItem = this.state.suggestions[this.state.focusedOption];
    if (selectedItem) {
      this.setItem(selectedItem.Value);
    }
    this.hideSuggestions();
  };

  hideSuggestions = () => {
    this.setState({ showSuggestions: false });
  };

  render() {
    return (
      <div className="autocomplete">
        <input
          type="text"
          className="address form-control"
          value={this.state.value}
          onChange={this.onChange}
          autoComplete="off"
          onKeyDown={this.onKeyDown}
          onBlur={this.hideSuggestions}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled ? true : false}
        />
        {this.state.showSuggestions && (
          <ul className="dropdown">
            {/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */}
            {this.state.suggestions.map((item, index) => (
              <li
                key={index}
                value={item.id}
                dangerouslySetInnerHTML={{ __html: item.Highlight }}
                onMouseDown={() => this.setItem(item.Value)}
                className={this.state.focusedOption === index ? 'focused' : ''}
              />
            ))}
            {/* eslint-enable jsx-a11y/no-noninteractive-element-interactions */}
          </ul>
        )}
      </div>
    );
  }
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/components/Autocomplete.js